import * as React from 'react';
import './TrialCategorysPage.scss';

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactTable, { RowInfo } from 'react-table';
import * as TrialCategoryActions from '../../../actions/trialCategorys';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FormFilterInput } from '../../../components/form';
import { TrialLookupsLayout } from '../../index';

interface ITrialCategorysPageProps {

    location: Location;
    history: History;

    // From state
    formFilter: IFormFilter;
    trialCategory: Dtos.TrialCategory[];
    loadingTrialCategorys: boolean;
    loadTrialCategorysSuccess: boolean;
    loadTrialCategorysFailure: boolean;

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    formRoles?: Dtos.RoleType[];
}

interface ITrialCategorysPageActions {
    clearTrialCategorys: TrialCategoryActions.ITrialCategoryClearActionCreator;
    loadTrialCategorys: TrialCategoryActions.ITrialCategoryLoadActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    filter: TrialCategoryActions.ITrialCategoryFilterActionCreator;
}

type TrialCategorysPageProps = ITrialCategorysPageProps & ITrialCategorysPageActions;

class TrialCategorysPage extends React.PureComponent<TrialCategorysPageProps, any> {

    constructor(props: TrialCategorysPageProps) {
        super(props);

        this.clearTrialCategorys = this.clearTrialCategorys.bind(this);
    }

    componentDidMount() {
        const {
            loadTrialCategorys
        } = this.props;

        loadTrialCategorys();
    }

    componentWillReceiveProps(nextProps: TrialCategorysPageProps) {
    }

    componentDidUpdate(prevProps: TrialCategorysPageProps, prevState) {
        const {
            navigateReplace
        } = this.props
    }

    componentWillUpdate(nextProps: TrialCategorysPageProps) {
    }

    componentWillUnmount() {
        this.clearTrialCategorys();
    }

    clearTrialCategorys() {
        this.props.clearTrialCategorys();
    }

    showTrialCategorys(): boolean {
        const {
            loadingTrialCategorys,
            loadTrialCategorysSuccess
        } = this.props

        if (!loadingTrialCategorys && loadTrialCategorysSuccess) {
            return true;
        }

        return false;
    }

    render() {
        const {
            loadingTrialCategorys
        } = this.props;

        return <TrialLookupsLayout loading={loadingTrialCategorys} permission={Dtos.Permission.TrialCategoriesView}>
            {this.renderContent()}
        </TrialLookupsLayout>;
    }

    renderContent() {
        const {
            permissions
        } = this.props;

        return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Trial Categories</h2>
                </div>
                <div className="col-6" style={{ textAlign: 'right' }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e) } />
                    
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialCategoriesCreate) && (
                        <Link className={"btn btn-primary"} url={"/settings/trial/trialcategorys/create"}>Create</Link>
                    )}
                </div>
            </div>
            {
                !this.showTrialCategorys() ?
                    "Loading Trial Categories" :
                    null
            }
            {
                this.showTrialCategorys() ?
                    <div className="patient-tables mt-2">
                        {
                            this.createTable()
                        }
                    </div> :
                    null
            }
        </div>
    }

    createTable() {

        const {
            trialCategory
        } = this.props

        if (!trialCategory || trialCategory.length == 0) {
            return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no trial categories to view.</span>
            </div>
        }

        const showPagination = trialCategory.length > DEFAULT_PAGE_SIZE;

        return <div className="table-wrapper mb-3">
            <ReactTable
                data={trialCategory}
                pageSizeOptions={PAGE_SIZE_OPTIONS}
                defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : trialCategory.length}
                pageSize={showPagination ? undefined : trialCategory.length}
                showPagination={showPagination}
                className="-striped -highlight -clickable mb-3"
                noDataText="There are currently no trialCategory to display"
                resizable={false}
                getTdProps={(state, rowInfo: RowInfo, column, instance) => {
                    return {
                        onClick: (e, handleOriginal) => {

                            const url: string = "/settings/trial/trialcategorys/" + rowInfo.original.id;
                            this.props.navigate(url);

                            if (handleOriginal) {
                                handleOriginal()
                            }

                        },
                        style: {
                            color: (rowInfo && rowInfo.original && rowInfo.original.active) ? '#212529' : '#9e9e9e'
                        }
                    }
                }}
                columns={[
                    {
                        id: "id",
                        Header: ' ',
                        accessor: "id",
                        className: "d-flex align-items-center justify-content-center",
                        maxWidth: 50,
                        Cell: (props) => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
                    },
                    {
                        id: "value",
                        Header: 'Name',
                        accessor: 'value',
                        className: "d-flex align-items-left justify-content-left",
                        headerClassName: "text-left"
                    },
                    {
                        id: "validationMessage",
                        Header: 'Validation',
                        accessor: 'validationMessage',
                        className: "d-flex align-items-left justify-content-left",
                        headerClassName: "text-left"
                    }
                ]}
            />
        </div>

    }

}

const mapStateToProps = (state: ITmdState, ownProps: TrialCategorysPageProps): ITrialCategorysPageProps => {

    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        history: ownProps.history,
        location: state.routing.location,

        formFilter: state.trialCategorys.formFilter,
        trialCategory: state.trialCategorys.formFilteredData, 

        loadingTrialCategorys: state.trialCategorys.loadState && state.trialCategorys.loadState.status == RequestState.Pending,
        loadTrialCategorysSuccess: state.trialCategorys.loadState && state.trialCategorys.loadState.status == RequestState.Success,
        loadTrialCategorysFailure: state.trialCategorys.loadState && state.trialCategorys.loadState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        formRoles: state.user.formRoles
    };
};

const mapDispatchToProps = (dispatch): ITrialCategorysPageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadTrialCategorys: bindActionCreators(TrialCategoryActions.LoadTrialCategory, dispatch),
        clearTrialCategorys: bindActionCreators(TrialCategoryActions.Clear, dispatch),

        filter: bindActionCreators(TrialCategoryActions.Filter, dispatch),
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(TrialCategorysPage);
